import { lastDayOfMonth, startOfMonth, subYears } from 'date-fns';

import { formatDate, isNotDefined } from '@hsp/utilities';

import { BluebookStatus } from '@t/p/bluebook/components/filter/status.enum';

export const loaderDefaults = (startDate?: string | null, endDate?: string | null, status?: string | null) => {
  const date = new Date();
  const end = lastDayOfMonth(date);
  const start = subYears(startOfMonth(date), 1);

  return {
    endDate: isNotDefined(endDate) ? formatDate(end, 'yyyy-MM-dd') : endDate,
    startDate: isNotDefined(startDate) ? formatDate(start, 'yyyy-MM-dd') : startDate,
    status: isNotDefined(status) ? BluebookStatus.Active : (status as BluebookStatus),
  };
};
